import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default function iotPowerOfOne() {
  gsap.registerPlugin(ScrollTrigger, CustomEase);

  const fakeBackground = document.getElementById('iot-fake-background');
  const card = document.querySelector('.card');
  const cardFront = document.querySelector('.card-front');
  const cardBack = document.querySelector('.card-back');

  const sectionHybridIotHeading = document.querySelector('.hybridIot-heading');
  const sectionHybridIotGridItems = document.querySelectorAll('.section-hybridIot-grid-items');
  const sectionHybridIotImage = document.querySelector('.section-hybridIot-image');
  const tl = gsap.timeline({ paused: true, delay: 0 });
  const isReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if(isReduceMotion) return;

  let rotationValue = { y: 0 };

  if (!fakeBackground) return;

  gsap.set(card, { transformStyle: 'preserve-3d' });

  tl.fromTo(
    sectionHybridIotHeading,
    { opacity: 0, yPercent: 100 },
    { opacity: 1, yPercent: 0, ease: 'power2.out', duration: 1 }
  )
    .fromTo(
      sectionHybridIotGridItems,
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, ease: 'power2.out', duration: 1, stagger: 0.3 },
      '-=0.5'
    )
    .fromTo(sectionHybridIotImage, { opacity: 0 }, { opacity: 1, ease: 'power2.out', duration: 1 }, '-=0.5');

  let flipTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: '.card-wrapper',
      start: 'top 30%',
      end: 'bottom+=150% bottom',
      scrub: 1,
      pin: true,
      anticipatePin: 0,
      markers: false,
      onLeaveBack: () => {
        tl.pause(0);
      },
      onLeave: () => {
        tl.play();
      },
      onEnterBack: () => {
        gsap.to(rotationValue, { y: 0, duration: 1.4 });
      },
      onUpdate: ({ progress }) => {
        if (progress >= 1) {
          fakeBackground.classList.add('bg-blue-night');
        } else {
          fakeBackground.classList.remove('bg-blue-night');
        }
      }
    }
  });

  flipTimeline
    .to(rotationValue, {
      y: 180,
      ease: 'power3.inOut',
      duration: 1.45,
      onUpdate: function () {
        gsap.set(card, { rotationY: rotationValue.y });
        if (rotationValue.y > 90) {
          cardFront.style.visibility = 'hidden';
          cardBack.style.visibility = 'visible';
        } else {
          cardFront.style.visibility = 'visible';
          cardBack.style.visibility = 'hidden';
        }
      }
    })
    .to(
      card,
      {
        scale: () => {
          return 16;
        },
        ease: 'power3.inOut',
        duration: 2
      },
      '<'
    );

  const blockPowerOneName = document.querySelector('.iot-power-name');
  const one = blockPowerOneName.querySelector('.iot-power-name__one');

  if (!blockPowerOneName) {
    return;
  }

  let tlOne = gsap.timeline({
    scrollTrigger: {
      trigger: blockPowerOneName,
      start: 'top center',
      end: 'bottom+=200 center',
      scrub: true,
      markers: false
    }
  });

  tlOne
    .to(one, { y: () => '+=' + one.getBoundingClientRect().height, duration: 1 }, '33%') // au 1/3
    .to(one, { y: () => '+=' + one.getBoundingClientRect().height, duration: 1 }, '66%') // aux 2/3
    .to('#iot-power-name-one-2', { opacity: 1 }, '<');

  ScrollTrigger.sort();
}
